// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11381ylp >button{width:40px}\n._1e0c1txw{display:flex}\n._2lx21bp4{flex-direction:column}\n._t74o1ylp >button{height:40px}", ""]);
// Exports
module.exports = exports;
